

  <p-calendar id="Dateselctor" [(ngModel)]="defualtStartDate" [disabledDates]="disabledDates"
    [disabledDays]="disabledDays" (onShow)="onCalendarShown()" (onMonthChange)="onMonthChange($event)" showIcon="true"
    [dateFormat]="'dd/mm/yy'" inputId="icondisplay" [minDate]="minDate" (defaultDate)="defualtStartDate"
    (onSelect)="CheckDate($event)" (onClose)="onClose()">

  </p-calendar>
